const template = `
	<div class="quick-filters" :class="value ? 'quick-filters-shown' : ''">
		<div class="filter-toggle-box" @click="toggle">
			<s-icon icon="filter"></s-icon>
			{{ ii('QUICK_FILTERS') }}
			<i class="filter-arrow zmdi" :class="value ? 'zmdi-long-arrow-up' : 'zmdi-long-arrow-down'"></i>
		</div>
		<div class="toggle-box">
			<span class="filter-toggle-btn" @click="toggle">
				<i v-if="value" class="fa fa-remove"></i>
				<span v-else class="toggle-text">
					<i class="filter-toggle-icon zmdi zmdi-filter-list" :title="ii('QUICK_FILTERS')"></i>
				</span>
			</span>
		</div>
		<div class="quick-filters-list">
			<template v-if="ready">
				<div v-if="app.segments && app.segments.length" :class="activeMetric === 'segments' ? 'active-metric' : ''">
					<div class="metric-btn" @click="onMetricClick('segments')">
						{{ ii('SEGMENTS') }}
						<i
							class="filter-item-arrow zmdi"
							:class="activeMetric === 'segments' ? 'zmdi-chevron-up' : 'zmdi-chevron-down'"
						></i>
					</div>
					<div class="metric-values">
						<router-link
							v-for="segment in app.segments"
							:key="'segments_' + segment.id"
							:to="'?' + segment.query"
							:class="getSegmentLinkClass(segment)"
						>{{ segment.name }}</router-link>
					</div>
				</div>
				<div v-for="row in rows" :class="row.metric === activeMetric ? 'active-metric' : ''">
					<div class="metric-btn" @click="onMetricClick(row.metric)">
						{{ ii(titleMap[row.metric]) }}
						<i
							class="filter-item-arrow zmdi"
							:class="row.metric === activeMetric ? 'zmdi-chevron-up' : 'zmdi-chevron-down'"
						></i>
					</div>
					<div class="metric-values">
						<router-link
							v-for="val in row.vals"
							:key="row.metric + '_' + val"
							:to="getUrl(row.metric, val)"
							:class="getLinkClass(row.metric, val)"
						>{{ getValueText(row.metric, val) }}</router-link>
					</div>
				</div>
			</template>
		</div>
	</div>
`;

export default {
	template,
	props: ['value'],
	data() {
		return {
			activeMetric: null,
			domains: null,
			metricData: null,
			titleMap: {
				domain: 'Domains',
				geo: 'Countries',
				lang: 'Languages',
				source: 'Sources',
				browser: 'Browsers',
				os: 'OS',
				vendor: 'Vendors',
				device: 'Devices'
			}
		}
	},
	computed: {
		ready() {
			return !!(this.rows && this.app.segments);
		},
		rows() {
			if (!this.metricData || !this.domains) return;

			let rows = Object.keys(this.titleMap)
				.filter(metric => this.metricData.values[metric])
				.map(metric => {
					let vals = this.metricData.values[metric].filter(val => val).slice(0, 10);
					return { metric, vals, };
				});

			let owner = this.app.owner || 0;
			let domains = this.domains[owner] || [];

			let domainsData = {
				metric: 'domain',
				vals: domains.slice(0, 10)
			};
			return [domainsData, ...rows];
		}
	},
	methods: {
		toggle() {
			this.$emit('input', !this.value);
		},
		loadData() {
			this.store.get('domains').then(domains => {
				this.domains = domains;
			});
			this.store.get('distinctValues').then(data => {
				this.metricData = data;
			});
		},
		onMetricClick(metric) {
			if (metric === this.activeMetric) {
				this.activeMetric = null;
				this.storage.set('quickFilter', '-');
			} else {
				this.activeMetric = metric;
				this.storage.set('quickFilter', metric);
			}
		},
		getUrl(metric, val) {
			return this.getExtendedQueryUrl({[metric]: val});
		},
		getValueText(metric, val) {
			if (metric === 'geo') return this.getCountryByCode(val);
			if (metric === 'lang') return this.getLanguageByCode(val);
			if (metric === 'device') return this.ii(val);
			if (metric === 'source') return this.ii(val);
			return val;
		},
		getLinkClass(metric, val) {
			return this.app.query[metric] === val ? 'active-val' : '';
		},
		getSegmentLinkClass(segment) {
			return location.search === '?' + segment.query ? 'active-val' : '';
		}
	},
	watch: {
		rows() {
			if (this.activeMetric) return;
			this.activeMetric = this.storage.get('quickFilter') || this.rows[0].metric;
		}
	},
	mounted() {
		this.loadData();
		this.events.on('auth', e => {
			this.store.del('domains');
			this.store.del('distinctValues');
			this.loadData();
		});
	}
}